<script setup lang="ts">
import {PlanType} from "@/scripts/types/account";
import {useAccount} from "@/scripts/store/account";
import {storeToRefs} from "pinia";
import {computed, ref} from "vue";
import VPlanRequiredModalAlert from "@/scripts/components/app/common/VPlanRequiredModalAlert.vue";
import {LockClosedIcon} from '@heroicons/vue/24/outline'

export interface Props {
    plan: PlanType[];
    showLockLabel: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    showLockLabel: true,
});

const accountStore = useAccount()
const {account} = storeToRefs(accountStore);

const isAvailableInPlan = computed(() => {
    return props.plan.includes(account.value.currentPlan.label)
})

const isModalOpened = ref(false);

const closeModal = () => {
    isModalOpened.value = false;
};

const startInteraction = (e: Event) => {
    if (!isAvailableInPlan.value) {
        e.stopImmediatePropagation()
        isModalOpened.value = true
    }
}

</script>

<template>
    <div class="flex">
        <div @click.capture="startInteraction" class="mr-2">
            <slot></slot>
        </div>
        <div v-if="!isAvailableInPlan && props.showLockLabel" class="items-center">
            <span title="только для pro аккаунта и выше" class="inline-flex items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                <LockClosedIcon class="h-3 w-3 mr-1 text-white-200" aria-hidden="true"/> {{ props.plan[0] }}
            </span>
        </div>
    </div>
    <v-plan-required-modal-alert :isOpen="isModalOpened" @modal-close="closeModal"></v-plan-required-modal-alert>
</template>

<style scoped>

</style>